module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-7.eaedf2e8.svg";